import { Button, Card } from "react-bootstrap";
import React, { useMemo } from "react";

import MarksList from "./MarksList";

export default function MarksPanel({
  activeType,
  marks,
  selectedId,
  setSelectedId,
  onDeleteSelected,
  showAdvanced,
}) {
  const hasItems = (marks?.length || 0) > 0;

  const title = useMemo(() => {
    if (activeType === "SINGLE") return "Unidades simples";
    if (activeType === "DOUBLE") return "Unidades duplas";
    if (activeType === "TRIPLE") return "Unidades triplas";
    return "Óstios";
  }, [activeType]);

  // Regra: mostrar só o que tem conteúdo
  if (!hasItems && !showAdvanced) return null;

  return (
    <Card className="tricho-card mt-3">
      <Card.Body>
        <div className="tricho-panel-head">
          <div className="tricho-panel-title">{title}</div>
          <div className="d-flex gap-2">
            <Button
              size="sm"
              variant="outline-danger"
              disabled={!selectedId}
              onClick={onDeleteSelected}
            >
              Excluir
            </Button>
          </div>
        </div>

        {!hasItems ? (
          <div className="tricho-mini-empty">
            Nenhuma marcação desse tipo (use clique e arraste na imagem).
          </div>
        ) : (
          <MarksList marks={marks} selectedId={selectedId} setSelectedId={setSelectedId} />
        )}
      </Card.Body>
    </Card>
  );
}
